import React from 'react';

import EventIcon from './event-icon';
import style from './index.less';

export const EventWechatCopy = props => {
  return (
    <div className={style['event-box']}>
      <ul className={style.header}>
        <li>
          <EventIcon action='mpush_clue' />
        </li>
        <li>用户已复制个微名片内容，请及时咨询是否完成添加</li>
      </ul>
    </div>
  );
};
